import {
  KakaoAlimtalkRecipientItemWithResult,
  KakaoFriendtalkRecipientItemWithResult,
} from '@gooduncles/gu-app-schema';
import { partition } from 'lodash-es';

/**
 * 요청 결과를 정리한 문자열을 생성한다.
 * @param recipientWithResultList
 */
export function organizeKakaotalkResultMessage<T>(
  recipientWithResultList: (KakaoAlimtalkRecipientItemWithResult<T> | KakaoFriendtalkRecipientItemWithResult)[]
) {
  const [success, fail] = partition(recipientWithResultList, (item) => item.result?.requestResult.result === 'success');
  // 수신자가 한 명인 메시지의 경우는 짧은 텍스트로 요약한다.
  if (recipientWithResultList.length === 1) {
    return success.length > 0 ? "요청 성공\n실제 수신여부는 '카톡 메시지 결과'에서 확인해주세요." : '요청 실패';
  }
  return `요청: ${recipientWithResultList.length}건, 성공: ${success.length}건, 실패: ${fail.length}건\n실제 수신여부는 '카톡 메시지 결과'에서 확인해주세요.`;
}
